import React from 'react';
import classNames from 'classnames';

import s from './index.module.scss';

export interface DSButtonContentProps {
	// If just want to display an icon button just pass the icon as children and set treatChildrenAsIcon to true if the children is not an BringgIcon icon element
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;

	children?: React.ReactNode;
}

/**
 * Content of buttons like DSButton and DSLinkButton
 *
 * @internal
 */
export function DSButtonContent({ leftIcon, rightIcon, children }: DSButtonContentProps) {
	return (
		<>
			{leftIcon ? (
				<span
					className={classNames(s.iconContainer, {
						[s.padLeft]: leftIcon && (children || rightIcon)
					})}
				>
					{leftIcon}
				</span>
			) : null}
			{children}
			{rightIcon ? (
				<span
					className={classNames(s.iconContainer, {
						[s.padRight]: rightIcon && children
					})}
				>
					{rightIcon}
				</span>
			) : null}
		</>
	);
}
